/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from "react";
import type { NRErrorInfo } from "@swiggy-private/js-utils";
import type { GetSwiggyHeadersResponsePayload, NativeBridge } from "@swiggy-private/native-bridge";
import { WidgetControllerContext } from "@swiggy-private/dls-react-mxn/dist";
import type { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
import { ScreenNames } from "@swiggy-private/portal-dineout-context";
import { IApiConfigs } from "@swiggy-private/portal-dineout-context";
import { BottomWidget, Container, FlexContainer } from "./styles";
import { PLWidgetRenderer } from "../PLWidgetRenderer";

interface ITrackProps {
    cards: IPLWidgetControllerCards[];
    popupConfigs?: IApiConfigs;
    sdk: NativeBridge;
    headers: GetSwiggyHeadersResponsePayload;
    clickAnalytics?: (clickObject: Record<string, any>) => void;
    impressionAnalytics?: (clickObject: Record<string, any>) => void;
    genericOnclick: (_?: any, extraParams?: Record<string, any>) => Promise<void>;
    onInvalidWidget: (widgetName?: string) => void;
    onWidgetError: (error: NRErrorInfo, widgetName?: string) => void;
    onEmptyPage: () => void;
    /** Screen name for analytics */
    screenName: ScreenNames;
}

const Track = ({
    cards,
    popupConfigs,
    sdk,
    clickAnalytics,
    impressionAnalytics,
    headers,
    genericOnclick,
    onInvalidWidget,
    onWidgetError,
    onEmptyPage,
    screenName,
}: ITrackProps) => {
    const contextValue = useMemo(() => {
        return {
            sdk: sdk,
            impressionAnalytics,
            clickAnalytics,
            headers,
            clickHandler: genericOnclick,
        };
    }, [clickAnalytics, genericOnclick, headers, impressionAnalytics, sdk]);

    return (
        <Container>
            <FlexContainer>
                <WidgetControllerContext.Provider value={contextValue}>
                    <PLWidgetRenderer
                        cards={cards}
                        popupConfigs={popupConfigs}
                        screenName={screenName}
                        onInvalidWidget={onInvalidWidget}
                        onWidgetError={onWidgetError}
                        onEmptyPage={onEmptyPage}
                    />
                </WidgetControllerContext.Provider>
                <BottomWidget />
            </FlexContainer>
        </Container>
    );
};

export default React.memo(Track);
